"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormBodyContainer = exports.Description = exports.ErrorContainer = exports.LoadingSpinnerContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("../../../../assets/styles/config");
exports.LoadingSpinnerContainer = styled_components_1.default.div `
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
`;
exports.ErrorContainer = styled_components_1.default.div `
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 2rem;

  i {
    color: ${config_1.colors.redError};
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  p {
    font-family: ${config_1.fontFamilies.primary};
    line-height: 1.5rem;
    text-align: center;
  }
`;
exports.Description = styled_components_1.default.p `
  color: ${config_1.colors.thundercloud};
  line-height: 1.3rem;
  margin-bottom: 1rem;
`;
exports.FormBodyContainer = styled_components_1.default.div `
  border-bottom: 1px solid ${config_1.colors.huron};
  border-top: 1px solid ${config_1.colors.huron};
  padding: 1rem;

  label,
  p {
    font-family: ${config_1.fontFamilies.primary};
    font-size: ${config_1.fontSizes.small};
  }
`;
